<template>
  <v-container>
    <v-app>
      <!--toolbar escritorio-->
      <v-toolbar
        v-if="toolbarEscritorio"
        color="tiendasimilia"
        dark
        width="100%"
        height="80"
        absolute
      >
        <v-img
          class="shrink mr-2"
          contain
          src="./assets/logo.png"
          transition="scale-transition"
          centered
        />

        <v-container class="text-right">
          <!--dialogo novedades escritorio-->
          <!--fin dialogo novedades escritorio-->
          <v-tooltip bottom color="yellow darken-3">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                style="white-space: normal"
                color="white"
                small
                href="https://novedades.similia.com.ar"
                target="_blank"
                text
                class="pr-4"
                v-bind="attrs"
                v-on="on"
              >
                ¡Novedades!
                <v-icon color="yellow">mdi-star</v-icon>
              </v-btn>
            </template>
            <span>Mira las últimas novedades en nuestro vademecum!</span>
          </v-tooltip>
          <v-tooltip bottom color="orange darken-3">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                style="white-space: normal"
                color="white"
                small
                href="http://similiavadi.dyndns.org:9987/index.html"
                target="_blank"
                text
                class="pr-4"
                v-bind="attrs"
                v-on="on"
              >
                <span class="mr-2">Vademecum Magistral</span>
                <v-icon color="orange darken-3">mdi-pill</v-icon>
              </v-btn>
            </template>
            <span>¡Visita el nuevo vademecum de formulas magistrales!</span>
          </v-tooltip>
          <v-tooltip bottom color="pink">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                style="white-space: normal"
                small
                href="http://similiavadi.dyndns.org:9989/index.html"
                target="_blank"
                text
                class="pr-4"
                color="white"
                v-bind="attrs"
                v-on="on"
              >
                <span class="mr-2">Vademecum Dermatológico</span>
                <v-icon color="pink">mdi-bottle-tonic-plus</v-icon>
              </v-btn>
            </template>
            <span>¡Visita el nuevo vademecum de formulas dermatológicas!</span>
          </v-tooltip>
          <v-tooltip bottom color="similiaazul">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                style="white-space: normal"
                small
                href="https://www.similia.com.ar"
                target="_blank"
                text
                class="pr-4"
                v-bind="attrs"
                v-on="on"
              >
                <span class="mr-2">Tienda</span>
                <v-icon>mdi-cart</v-icon>
              </v-btn>
            </template>
            <span
              >¡Visita nuestra tienda online y encontra los mejores precios y
              descuentos!</span
            >
          </v-tooltip>
        </v-container>
      </v-toolbar>
      <!--fin toolbar escritorio-->

      <!--toolbar movil-->
      <v-toolbar
        v-if="!toolbarEscritorio"
        color="tiendasimilia"
        dark
        width="100%"
        height="150"
        absolute
      >
        <v-container class="text-center">
          <v-row no-gutters>
            <v-col cols="12" md="12">
              <v-img
                class="shrink mr-2"
                contain
                src="./assets/logo.png"
                transition="scale-transition"
                centered
                max-height="50"
              />
            </v-col>
          </v-row>

          <v-tooltip bottom color="yellow darken-3">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                style="white-space: normal"
                color="white"
                small
                href="https://novedades.similia.com.ar"
                target="_blank"
                text
                class="pr-4"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="yellow">mdi-star</v-icon>
                ¡Novedades!
                <v-icon color="yellow">mdi-star</v-icon>
              </v-btn>
            </template>
            <span>Mira las últimas novedades en nuestro vademecum!</span>
          </v-tooltip>
          <v-row no-gutters>
            <v-col cols="12" md="12">
              <v-tooltip bottom color="orange darken-3">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    style="white-space: normal"
                    color="white"
                    small
                    href="http://similiavadi.dyndns.org:9987/index.html"
                    target="_blank"
                    text
                    class="pr-4"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small color="orange darken-3">mdi-pill</v-icon>
                    <span class="mr-2">Vademecum Magistral</span>
                    <v-icon small color="orange darken-3">mdi-pill</v-icon>
                  </v-btn>
                </template>
                <span>¡Visita el nuevo vademecum de formulas magistrales!</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" md="12">
              <v-tooltip bottom color="pink">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    style="white-space: normal"
                    small
                    href="http://similiavadi.dyndns.org:9989/index.html"
                    target="_blank"
                    text
                    class="pr-4"
                    color="white"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small color="pink">mdi-bottle-tonic-plus</v-icon>
                    <span class="mr-2">Vademecum Dermatológico</span>
                    <v-icon small color="pink">mdi-bottle-tonic-plus</v-icon>
                  </v-btn>
                </template>
                <span>¡Visita el nuevo vademecum de formulas dermatológicas!</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" md="12">
              <v-tooltip bottom color="similiaazul">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    style="white-space: normal"
                    small
                    href="https://www.similia.com.ar"
                    target="_blank"
                    text
                    class="pr-4"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small>mdi-cart</v-icon>
                    <span class="mr-2">Tienda Similia</span>
                    <v-icon small>mdi-cart</v-icon>
                  </v-btn>
                </template>
                <span
                  >¡Visita nuestra tienda online y encontra los mejores precios y
                  descuentos!</span
                >
              </v-tooltip>
            </v-col>
          </v-row>
        </v-container>
      </v-toolbar>
      <!--fin toolbar movil-->
      <v-card height="80" color="rgb(255, 0, 0, 1)"></v-card>
      <v-main>
        <VadiMain />
      </v-main>
    </v-app>
  </v-container>
</template>

<script>
import VadiMain from "./views/VadiMain";
import VueScreenSize from "vue-screen-size";

export default {
  name: "App",
  mixins: [VueScreenSize.VueScreenSizeMixin],
  components: {
    VadiMain,
  },

  data() {
    return {
      toolbarEscritorio: true,
      // dialogoNovedades: true,
      // dialogoNovedadesCelu: true,
      colors: [
        "indigo",
        "warning",
        "pink darken-2",
        "red lighten-1",
        "deep-purple accent-4",
      ],

      // items2: [
      //   {
      //     src: "https://similia.com.ar/vadinews/novedadCelu1.png",
      //   },
      //   {
      //     src: "https://similia.com.ar/vadinews/novedadCelu2.png",
      //   },
      //   {
      //     src: "https://similia.com.ar/vadinews/novedadCelu3.png",
      //   },
      //   {
      //     src: "https://similia.com.ar/vadinews/novedadCelu4.png",
      //   },
      //   {
      //     src: "https://similia.com.ar/vadinews/novedadCelu5.png",
      //   },
      //   {
      //     src: "https://similia.com.ar/vadinews/novedadCelu6.png",
      //   },
      //   {
      //     src: "https://similia.com.ar/vadinews/novedadCelu7.png",
      //   },
      //   {
      //     src: "https://similia.com.ar/vadinews/novedadCelu8.png",
      //   },
      // ],
      // items: [
      //   {
      //     src: "https://similia.com.ar/vadinews/novedad1.png",
      //   },
      //   {
      //     src: "https://similia.com.ar/vadinews/novedad2.png",
      //   },
      //   {
      //     src: "https://similia.com.ar/vadinews/novedad3.png",
      //   },
      //   {
      //     src: "https://similia.com.ar/vadinews/novedad4.png",
      //   },
      //   {
      //     src: "https://similia.com.ar/vadinews/novedad5.png",
      //   },
      //   {
      //     src: "https://similia.com.ar/vadinews/novedad6.png",
      //   },
      //   {
      //     src: "https://similia.com.ar/vadinews/novedad7.png",
      //   },
      //   {
      //     src: "https://similia.com.ar/vadinews/novedad8.png",
      //   },
      // ],
    };
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      if (this.$vssWidth > 600) {
        this.toolbarEscritorio = true;
      } else {
        this.toolbarEscritorio = false;
      }
    },

    // dialogo4: function () {
    //   if (this.$vssWidth > 600) {
    //     this.dialogoNovedades = true;
    //   } else {
    //     this.dialogoNovedadesCelu = true;
    //   }
    // },
  },
};
</script>
